import { colors } from '@airwallex/global';
export var alertTheme = {
  background: {
    color: {
      success: colors.greens[10],
      informational: colors.greys[10],
      warning: colors.yellows[10],
      critical: colors.oranges[10]
    }
  },
  icon: {
    background: {
      color: {
        success: colors.greens[70],
        informational: colors.greys[60],
        warning: colors.oranges[50],
        critical: colors.reds[50]
      }
    }
  },
  closeIcon: {
    hover: {
      background: {
        success: colors.greens[70],
        informational: colors.greys[60],
        warning: colors.oranges[50],
        critical: colors.reds[50]
      },
      color: colors.white
    },
    color: {
      success: colors.greens[70],
      informational: colors.greys[60],
      warning: colors.oranges[50],
      critical: colors.reds[50]
    }
  },
  link: {
    color: colors.greys[100],
    textDecorationColor: colors.greys[40],
    hover: {
      textDecorationColor: colors.greys[90]
    },
    active: {
      color: colors.greys[90],
      textDecorationColor: colors.greys[20]
    },
    focus: {
      outline: "1px solid ".concat(colors.greys[100])
    }
  },
  button: {
    color: colors.greys[80],
    border: {
      color: 'rgba(0,0,0,0.3)'
    },
    hover: {
      background: {
        color: 'rgba(255, 255, 255, 0.3)'
      }
    }
  }
};